export function getPhoneVerdict(enrichments) {
  const consensus = enrichments?.carrier_consensus?.data || {};
  const assigned = enrichments?.assigned_carrier?.data || {};
  const liveWrap = enrichments?.live_carrier || {};
  const live = liveWrap?.data || {};
  const voipAnalysis = enrichments?.voip_analysis?.data || {};
  const numberType = enrichments?.number_type?.data || {};

  const liveStatus = liveWrap?.status;
  const hasLiveSuccess = liveStatus === 'success';

  let verdict = 'inconclusive';
  let headline = 'Line type inconclusive';
  let detail = consensus.voip_summary || consensus.summary || 'Run live carrier lookup for definitive classification.';
  let confidence = consensus.confidence || 'low';

  const voipConsensus = consensus.voip_consensus;

  if (voipConsensus === 'confirmed' || (hasLiveSuccess && live.is_voip)) {
    verdict = 'voip';
    headline = 'VoIP / virtual number';
    detail = consensus.voip_summary || `Live lookup reports ${live.line_type || 'VoIP'}.`;
    confidence = voipConsensus === 'confirmed' ? 'high' : 'medium';
  } else if (voipConsensus === 'live_only' && live.is_voip) {
    verdict = 'voip';
    headline = 'VoIP (live lookup)';
    detail = consensus.voip_summary || `Carrier: ${live.carrier || 'unknown'}.`;
    confidence = 'medium';
  } else if (voipConsensus === 'assigned_only' || assigned.is_voip) {
    verdict = 'likely_voip';
    headline = 'Likely VoIP infrastructure';
    detail = consensus.voip_summary || assigned.voip_detail || 'LERG assignment points to VoIP carrier infrastructure.';
    confidence = 'medium';
  } else if (hasLiveSuccess && !live.is_voip) {
    const line = (live.line_type || '').toLowerCase();
    verdict = line.includes('wireless') || line.includes('mobile') ? 'real_wireless' : 'real_landline';
    headline = live.line_type || 'Standard carrier line';
    detail = `Live carrier: ${live.carrier || 'unknown'}. ${consensus.summary || ''}`.trim();
    confidence = 'high';
  } else if (assigned.line_type && !assigned.is_voip) {
    const line = (assigned.line_type || '').toLowerCase();
    verdict = line.includes('wireless') || line.includes('mobile') ? 'real_wireless' : 'real_landline';
    headline = assigned.line_type;
    detail = `LERG assignment: ${assigned.carrier || 'unknown'}. Live lookup recommended to confirm post-porting carrier.`;
    confidence = 'medium';
  } else if (voipAnalysis.is_voip) {
    verdict = 'likely_voip';
    headline = `Possible VoIP (${voipAnalysis.voip_likelihood || 'heuristic'})`;
    const indicators = Array.isArray(voipAnalysis.indicators) ? voipAnalysis.indicators : [];
    detail = indicators.filter((item) => item !== 'No VoIP indicators detected').join(' ') || detail;
    confidence = 'low';
  } else if (numberType.type && numberType.type !== 'Unknown') {
    verdict = 'inconclusive';
    headline = numberType.type;
    detail = numberType.detail || detail;
    confidence = 'low';
  }

  const liveReason = live.reason || live.error || '';
  const showLiveAction = liveStatus !== 'success';

  return {
    verdict,
    headline,
    detail,
    confidence,
    consensus,
    assigned,
    live,
    liveStatus,
    liveReason,
    voipAnalysis,
    showLiveAction,
  };
}

export function verdictConfidenceLabel(confidence) {
  if (confidence === 'high') return 'High confidence';
  if (confidence === 'medium') return 'Medium confidence';
  return 'Low confidence';
}
